export const version = 'v2.2.4-2070-gd34340cfb'
